import api from 'utils/apiClient';

export const createPublication = (data) => {
  return api.post('/publications', data);
};
